import { Box, Button } from '@mui/material'
import { INode } from 'shared/types/tree'
import React from 'react'
import { exportKiddomTreeToSpreadsheet } from './utilities'

export function ExportStandards({
  tree,
  accessToken,
}: {
  tree: INode
  accessToken: string
}) {
  const [spreadsheetId, setSpreadsheetId] = React.useState<string>()
  const [exporting, setExporting] = React.useState(false)

  return (
    <Box>
      <h2>Export</h2>
      <Button
        disabled={exporting}
        onClick={() => {
          setExporting(true)
          exportKiddomTreeToSpreadsheet(tree, accessToken).then((s) => {
            setSpreadsheetId(s)
            setExporting(false)
          })
        }}
      >
        {exporting ? 'Exporting...' : 'Export Spreadsheet'}
      </Button>

      {spreadsheetId && (
        <Box>
          Exported to:{' '}
          <a
            href={`https://docs.google.com/spreadsheets/d/${spreadsheetId}`}
            target="_blank"
          >
            https://docs.google.com/spreadsheets/d/{spreadsheetId}
          </a>
        </Box>
      )}
    </Box>
  )
}
